import { useNavigate } from "react-router-dom";

const usePopupAction = () => {
  const navigate = useNavigate();

  const navigateTo = (route, selectedPhotoPoint) => {
    navigate(route, {
      replace: true,
      state: {
        ACCOUNTCODE: selectedPhotoPoint.ACCOUNTCODE,
        COMMENTS: selectedPhotoPoint.COMMENTS,
        CONDITION: selectedPhotoPoint.CONDITION,
        CREATED_DATE: selectedPhotoPoint.CREATED_DATE,
        CREATED_USER: selectedPhotoPoint.CREATED_USER,
        CREATION_USER: selectedPhotoPoint.CREATION_USER,
        FEATURE: selectedPhotoPoint.FEATURE,
        HAS_PHOTO_POINT: selectedPhotoPoint.HAS_PHOTO_POINT,
        LAST_EDITED_DATE: selectedPhotoPoint.LAST_EDITED_DATE,
        LAST_EDITED_USER: selectedPhotoPoint.LAST_EDITED_USER,
        LEGACY_STRUCTURE_NAME: selectedPhotoPoint.LEGACY_STRUCTURE_NAME,
        LOCATION: selectedPhotoPoint.LOCATION,
        MIDSPAN_HEIGHT_FEET: selectedPhotoPoint.MIDSPAN_HEIGHT_FEET,
        MIDSPAN_HEIGHT_INCHES: selectedPhotoPoint.MIDSPAN_HEIGHT_INCHES,
        OBJECTID: selectedPhotoPoint.OBJECTID,
        SDE_TABLE: selectedPhotoPoint.SDE_TABLE,
        STATUS: selectedPhotoPoint.STATUS,
        STRUCTURE_NAME: selectedPhotoPoint.STRUCTURE_NAME,
        THREEGISID: selectedPhotoPoint.THREEGISID,
        USER_LATITUDE: selectedPhotoPoint.USER_LATITUDE,
        USER_LONGITUDE: selectedPhotoPoint.USER_LONGITUDE,
      },
    });
  };

  const handleViewPopupAction = ({
    accountcode,
    attributes,
    authCtx,
    ID,
    location,
    photoPoint,
    photoPointLayer,
    setNoPhotoPoint,
    setReadonlyPrompt,
    userLocation,
  }) => {
    const checkUserReadonly = () => {
      if (authCtx.isReadOnly) {
        setReadonlyPrompt(true);
        return true;
      }
    };

    const updateDefaultPhotoPointValues = () => {
      photoPoint.ACCOUNTCODE = accountcode || null;
      photoPoint.LOCATION = location;
      photoPoint.USER_LATITUDE = userLocation.latitude;
      photoPoint.USER_LONGITUDE = userLocation.longitude;
      photoPoint.PHOTO_POINT_LAYER = photoPointLayer;
    };

    const hasPhotoPointObject = (sdeTable) => {
      return {
        ...photoPoint,
        HAS_PHOTO_POINT: true,
        SDE_TABLE: sdeTable,
      };
    };

    const noPhotoPointObject = (sdeTable) => {
      return {
        STRUCTURE_NAME: attributes?.STRUCTURE_NAME,
        THREEGISID: attributes?.THREEGISID,
        SDE_TABLE: sdeTable,
        HAS_PHOTO_POINT: false,
      };
    };

    const viewPhotosHandler = () => {
      if (!photoPoint) {
        setNoPhotoPoint(true);
        return;
      }
      photoPoint.NAME = attributes?.STRUCTURE_NAME;
      updateDefaultPhotoPointValues();
      navigateTo("/editPhotoPointPhotos", photoPoint);
    };

    const editStructureHandler = () => {
      !photoPoint
        ? (photoPoint = noPhotoPointObject("STRUCTURE"))
        : (photoPoint = hasPhotoPointObject("STRUCTURE"));
      updateDefaultPhotoPointValues();
      navigateTo("/collect", photoPoint);
    };

    const editSpliceClosureHandler = () => {
      !photoPoint
        ? (photoPoint = noPhotoPointObject("SPLICECLOSURE"))
        : (photoPoint = hasPhotoPointObject("SPLICECLOSURE"));
      updateDefaultPhotoPointValues();
      navigateTo("/collect", photoPoint);
    };

    const editPoleHandler = () => {
      !photoPoint
        ? (photoPoint = noPhotoPointObject("POLE"))
        : (photoPoint = hasPhotoPointObject("POLE"));
      updateDefaultPhotoPointValues();
      navigateTo("/collect", photoPoint);
    };

    const editGreenfieldHandler = () => {
      !photoPoint
        ? (photoPoint = noPhotoPointObject(""))
        : (photoPoint = hasPhotoPointObject(""));
      updateDefaultPhotoPointValues();
      navigateTo("/collect", photoPoint);
    };

    // Action button ID switch.
    switch (ID) {
      case "viewPhotos":
        viewPhotosHandler();
        break;
      case "editStructure":
        if (checkUserReadonly()) break;
        editStructureHandler();
        break;
      case "editSpliceClosure":
        if (checkUserReadonly()) break;
        editSpliceClosureHandler();
        break;
      case "editPole":
        if (checkUserReadonly()) break;
        editPoleHandler();
        break;
      case "editGreenfield":
        if (checkUserReadonly()) break;
        editGreenfieldHandler();
        break;
      default:
        break;
    }
  };

  return handleViewPopupAction;
};

export default usePopupAction;
